<template>
  <div style="background:#267e67" id="nav">
    <ul>
      <li><a href="javascript:void(0)" @click="indexClick">市级首页</a>|</li>
      <li><a href="javascript:void(0)" @click="cityIndexClick">本站首页</a>|</li>
      <li><a href="javascript:void(0)" @click="cityagriculturalServicesClick">地方快讯</a>|</li>
      <li><a href="javascript:void(0)" @click="LocalExpressClick">经营主体</a>|</li>
      <li><a href="javascript:void(0)">土地托管</a>|
        <ul>
          <li><a href="javascript:void(0)" @click="LandBantuoClick">土地半托</a></li>
          <li><a href="javascript:void(0)" @click="LandTrustClick">土地全托</a></li>
        </ul>
      </li>
      <li><a href="javascript:void(0)"  @click="LandTransferClick"> 土地流转</a>|</li>
      <li><a href="javascript:void(0)">农业人才</a>|
        <ul>
          <li><a href="javascript:void(0)" @click="ProfessionalsClick">专业人才</a></li>
          <li><a href="javascript:void(0)" @click="Expert_ConsultationClick">农村劳务</a></li>
        </ul>
      </li>
      <li><a href="javascript:void(0)" @click="Farm_Machine_CooperatimeListClick"> 农机服务</a>|</li>
      <li><a href="javascript:void(0)">金融保险</a>|
        <ul>
          <li><a href="javascript:void(0)" @click="AgriculturalLoanClick">农业贷款</a></li>
          <li><a href="javascript:void(0)" @click="AgriculturalInsuranceClick">农业保险</a></li>
        </ul>
      </li>
      <li><a href="javascript:void(0)">供求信息</a>|
        <ul>
          <li><a href="javascript:void(0)" @click="SupplyClick">供应信息</a></li>
          <li><a href="javascript:void(0)" @click="DemindClick">求购信息</a></li>
        </ul>
      </li>
      <li><a href="javascript:void(0)">科技展鹏</a>|
        <ul>
          <li><a href="javascript:void(0)" @click="TechnologyClassroomClick">农技课堂</a></li>
          <li><a href="javascript:void(0)" @click="DoctorClick">庄家医生</a></li>
        </ul>
      </li>
      <li><a href="javascript:void(0)" @click="Farm_Machine_CooperatimeListClick"> 数据分析</a></li>
    </ul>
    <div style="clear:both"></div>
    <!-- <a-menu mode="horizontal" style="background:none;width:80%;margin:auto">
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper" @click="indexClick"> 市级首页</span>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper" @click="cityIndexClick">  本站首页</span>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper" @click="cityagriculturalServicesClick"> 地方快讯</span>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper" @click="LocalExpressClick"> 经营主体</span>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper"> 土地托管</span>
        <a-menu-item @click="LandBantuoClick">
          土地半托
        </a-menu-item>
        <a-menu-item @click="LandTrustClick">
          土地全托
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper" @click="LandTransferClick"> 土地流转</span>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper" > 农业人才</span>
        <a-menu-item @click="ProfessionalsClick">
          专业人才
        </a-menu-item>
        <a-menu-item @click="Expert_ConsultationClick">
          农村劳务
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper" @click="Farm_Machine_CooperatimeListClick"> 农机服务</span>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper"> 金融保险</span>
        <a-menu-item @click="AgriculturalLoanClick">
          农业贷款
        </a-menu-item>
        <a-menu-item @click="AgriculturalInsuranceClick">
          农业保险
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper"> 供求信息</span>
        <a-menu-item @click="SupplyClick">
          供应信息
        </a-menu-item>
        <a-menu-item @click="DemindClick">
          求购信息
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper"> 科技展鹏</span>
        <a-menu-item @click="TechnologyClassroomClick">
          农技课堂
        </a-menu-item>
        <a-menu-item @click="DoctorClick">
          庄家医生
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper"> 数据分析</span>
      </a-sub-menu>
    </a-menu> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      sysTitle: ''
    }
  },
  methods: {
    indexClick() {
      const go = this.$router.resolve({ path: '/' })
      window.open(go.href, '_blank')
    },
    cityIndexClick() {
     const go = this.$router.resolve({ path: '/cityIndex' })
     window.open(go.href, '_blank')
    },
    /** */
    AgriculturalLoanClick() {
      this.sysTitle = '农业贷款'
      this.cityagriculturalServicesClick()
    },
    AgriculturalInsuranceClick() {
      this.sysTitle = '农业保险'
      this.cityagriculturalServicesClick()
    },
    SupplyClick() {
      this.sysTitle = '供应信息'
      this.cityagriculturalServicesClick()
    },
    DemindClick() {
      this.sysTitle = '求购信息'
      this.cityagriculturalServicesClick()
    },
    TechnologyClassroomClick() {
      this.sysTitle = '农技课堂'
      this.cityagriculturalServicesClick()
    },
    DoctorClick() {
      this.sysTitle = '庄稼医生'
      this.cityagriculturalServicesClick()
    },
    cityagriculturalServicesClick() {
      if (this.sysTitle === '农业贷款') {
       const go = this.$router.resolve({ path: 'cityagriculturalServices', query: { title: '农业贷款' } })
       window.open(go.href, '_blank')
      } else if (this.sysTitle === '农业保险') {
        const go = this.$router.resolve({ path: 'cityagriculturalServices', query: { title: '农业保险' } })
        window.open(go.href, '_blank')
      } else if (this.sysTitle === '供应信息') {
        const go = this.$router.resolve({ path: 'cityagriculturalServices', query: { title: '供应信息' } })
        window.open(go.href, '_blank')
      } else if (this.sysTitle === '求购信息') {
        const go = this.$router.resolve({ path: 'cityagriculturalServices', query: { title: '求购信息' } })
        window.open(go.href, '_blank')
      } else if (this.sysTitle === '农技课堂') {
        const go = this.$router.resolve({ path: 'cityagriculturalServices', query: { title: '农技课堂' } })
        window.open(go.href, '_blank')
      } else if (this.sysTitle === '庄稼医生') {
        const go = this.$router.resolve({ path: 'cityagriculturalServices', query: { title: '庄稼医生' } })
        window.open(go.href, '_blank')
      }
    },
    /** */
    Expert_ConsultationClick() {},
    LocalExpressClick() {
      this.sysTitle = '经营主体'
      this.cityBrand_publicClick()
    },
    LandBantuoClick() {
      this.sysTitle = '土地半托'
      this.cityBrand_publicClick()
    },
    LandTrustClick() {
      this.sysTitle = '土地全托'
      this.cityBrand_publicClick()
    },
    LandTransferClick() {
      this.sysTitle = '土地流转'
      this.cityBrand_publicClick()
    },
    ProfessionalsClick() {
      this.sysTitle = '专业人才'
      this.cityBrand_publicClick()
    },
    Farm_Machine_CooperatimeListClick() {
      const go = this.$router.replace('/cityAgriculturalMachinery')
      window.open(go.href, '_blank')
    },
    cityBrand_publicClick() {
      if (this.sysTitle === '经营主体') {
      const go = this.$router.replace({ path: 'cityBrandPublic', query: { title: '经营主体', inputTitle: '名称' } })
      window.open(go.href, '_blank')
      } else if (this.sysTitle === '土地半托') {
      const go = this.$router.replace({ path: 'cityBrandPublic', query: { title: '土地半托', inputTitle: '标题' } })
      window.open(go.href, '_blank')
      } else if (this.sysTitle === '土地半托') {
      const go = this.$router.replace({ path: 'cityBrandPublic', query: { title: '土地半托', inputTitle: '标题' } })
      window.open(go.href, '_blank')
      } else if (this.sysTitle === '土地流转') {
      const go = this.$router.replace({ path: 'cityBrandPublic', query: { title: '土地流转', inputTitle: '片区名称' } })
      window.open(go.href, '_blank')
      } else if (this.sysTitle === '专业人才') {
      const go = this.$router.replace({ path: 'cityBrandPublic', query: { title: '专业人才', inputTitle: '专业专长' } })
      window.open(go.href, '_blank')
      } else if (this.sysTitle === '农机服务') {
      const go = this.$router.replace({ path: 'cityBrandPublic', query: { title: '专业人才', inputTitle: '专业专长' } })
      window.open(go.href, '_blank')
      }
    }
  }

}
</script>

<style scoped>
ul,li,p,a{
  list-style: none;
  margin:0;
  padding:0;
}
  #nav{
    width:100%;
    background: #207e63;
    line-height: 46px;
  }
  #nav ul>li{
    float: left;
    position: relative;
  }
  #nav ul{
    width:80%;
    margin:auto;
    color:#FFF;
  }
  #nav ul li a{
    padding:0 13px;
    color:#FFF;
    font-size:15px;
    font-weight: bold;
  }
  #nav ul li ul{
    position: absolute;
    width:100%;
    background: #207e63;
    z-index: 99;
    display: none;
    top:47px;
    left: 0;
    border-top:1px solid #FFF;
  }
  #nav ul li ul li{
    width:100%;
  }
  #nav ul li:hover>ul{
    display: block;
  }
  #nav ul li ul li:hover{
    background: #e6dfcf;
  }
  #nav ul li ul li:hover a{
    color:green;
  }

</style>
